import axios from "axios";
import envs from "config/envs";

export const authenticate = async () => {
  try {
    return await axios.post(
      `${envs.NEW_SERVICE_URL}/servico/v1/auth/authorize`,
      {},
      {
        withCredentials: true,
      }
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const refreshAccessToken = async () => {
  return await axios.post(
    `${envs.NEW_SERVICE_URL}/servico/v1/auth/refresh`,
    {},
    {
      withCredentials: true,
    }
  );
};
